import * as React from "react";
import Container from '@mui/material/Container';
import {Box, Button, IconButton, Stack, Typography} from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import {useState, useEffect} from "react";
import {ActualityCard} from "../index";
import CommunityCard from "../community/CommunityCard";
import {InstitutionCard} from "../index";
import Slider from "react-slick";
import {Article as ArticleIcon, Highlight as HighlightIcon,
    Soap as SoapIcon, Group as GroupIcon, Apartment as ApartmentIcon,
    QueryStats as QueryStatsIcon, Celebration as CelebrationIcon, RemoveRedEye as RemoveRedEyeIcon}
    from '@mui/icons-material';
import WysiwygCard from "../wysiwyg/WysiwygCard";
import EventDetailCardRender from "../event/EventDetailCardRender";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import ServiceItemUser from "../service/ServiceItemUser";



const Result = ({
                    token, searchResponse, allowedResponse, setDisableSeeAll, setDisableActuality,
                    setDisableService, setDisableAdvice, setDisableCommunity, setDisableEstablishment,
                    setDisableSurvey, setDisableEvent, sliceMax, setTabValue
                }) => {
    const [showMoveUpButton, setShowMoveUpButton] = useState(false);
    const [showMoveDownButton, setShowMoveDownButton] = useState(true);
    const [anchor, setAnchor] = useState(0);
    const {mode} = useDarkMode();
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    arrows: false
                }
            }
        ],
        variableWidth : true
    };

    const header = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    const renderResult = (list) => {
        const final = [];
        let anchorNumber = 0;
        Object.entries(list).forEach((child) => {
            const childType = child[0];
            const childContent = child[1];
            setDisableSeeAll(false);
            console.log(childType);
            if (allowedResponse.indexOf(childType) > -1) {
                switch(childType) {
                    case 'actuality':
                        final.push(renderActuality(childContent,anchorNumber));
                        setDisableActuality(false);
                        anchorNumber++;
                        break;
                    case 'community':
                        final.push(renderCommunity(childContent,anchorNumber));
                        setDisableCommunity(false);
                        anchorNumber++;
                        break;
                    case 'institution':
                        final.push(renderInstitution(childContent,anchorNumber));
                        setDisableEstablishment(false);
                        anchorNumber++;
                        break;
                    case 'advice':
                        final.push(renderWysiwyg(childContent,anchorNumber, 'conseils','advice',
                            <img style={{ height : '25px', width : '30px' }}
                                 src={`/assets/icon/conseil-white.png`}
                                 alt={'Résultats de catégorie Conseils'}
                            />));
                        setDisableAdvice(false);
                        anchorNumber++;
                        break;
                    case 'service':
                        final.push(renderWysiwyg(childContent,anchorNumber, 'services','service',
                            <img style={{ height : '25px', width : '30px' }}
                                 src={`/assets/icon/service-white.png`}
                                 alt={'Résultats de catégorie Services'}
                            />));
                        setDisableService(false);
                        anchorNumber++;
                        break;
                    case 'produit':
                        final.push(renderWysiwyg(childContent,anchorNumber, 'Produits','produit',
                            <img style={{ height : '25px', width : '30px' }}
                                 src={`/assets/icon/product-white.png`}
                                 alt={'Résultats de catégorie Produit'}
                            />));
                        setDisableSurvey(false);
                        anchorNumber++;
                        break;
                    case 'event':
                        final.push(renderEvents(childContent,anchorNumber))
                        setDisableEvent(false);
                        anchorNumber++;
                        break;
                    default:
                }
            }
        })
        return (final);
    }

    const changeTab = (tabNumber) => {
        console.log('tabNumber',tabNumber)
        setTabValue(tabNumber);
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }

    const renderWysiwyg = (content, anchorNumber, title,id,icon) => {
        return (
            <div id={'resultContainer'} style={{backgroundColor: mode.settings.backgroundColor}}>
                <Container className={'container'} id={'anchor'+anchorNumber}>
                    {renderTitle(title, icon, 3)}
                    <div>
                        {content.slice(0,sliceMax).map((product,index) => (
                            <div key={index} id={sliceMax > 2?'anchor'+index:''}>
                                <ServiceItemUser
                                    id={product.id}
                                    title={product.name}
                                    description={product.description}
                                    variant={product.category}
                                    image={product.image}
                                    variantName={product.category}
                                    controls={['show-detail','marketplace', 'add-to-fav']}
                                    treading={false}
                                    treadingBadge={false}
                                    isFavorite={product.favorite}
                                    addMargin={true}
                                    wishlistId={product.wishlistId}
                                    wishListProductId={product.wishListIdProduct}
                                />

                            </div>
                        ))}
                    </div>
                    <br/>
                    {
                        sliceMax == 2 ?
                            <div style={{textAlign:"center", marginTop:-18}}>
                                <Button startIcon={<RemoveRedEyeIcon role={'img'} aria-label={"Voir tous les "+id} />}
                                        className='buttonOhs'
                                        onClick={() => {
                                            changeTab(3)
                                        }}
                                >
                                    <Typography variant={'subtitle3'}>{"Voir tous les "+ title}</Typography>
                                </Button><br/>
                            </div>
                            :''
                    }
                    <br/>
                </Container>
            </div>
        )
    }

    const renderActuality = (actuality, anchorNumber) => {
        return (
            <div id={'resultContainer'} style={{backgroundColor: mode.settings.backgroundColor}}>
                <Container className={'container'} id={sliceMax == 2?'anchor'+anchorNumber:''}>
                    {renderTitle('Actualités', <img style={{ height : '25px', width : '30px' }}
                                                    src={`/assets/icon/actuality-white.png`}
                                                    alt={'Voir les résultats de catégorie Evènements'}
                    />, 1)}
                    <div>
                        {actuality.slice(0,sliceMax).map((actuality,index) => (
                            <div key={index} id={sliceMax > 2?'anchor'+index:''}>
                                <ActualityCard actuality={actuality} header={header} showCommunityInfo={true}/>
                            </div>
                        ))}
                    </div>
                    <br/>
                    {
                        sliceMax == 2 ?
                         <div style={{textAlign:"center", marginTop:-18}}>
                             <Button startIcon={<RemoveRedEyeIcon role={'img'} aria-label="Voir tous les résultats actualités"/>}
                                     className='buttonOhs'
                                     onClick={() => {
                                         changeTab(1)
                                     }}
                             >
                                 <Typography variant={'subtitle3'}>Voir toutes les actualités</Typography>
                             </Button>
                             <br/>
                         </div>
                        :''
                    }
                    <br/>
                </Container>
            </div>
        )
    }

    const renderEvents = (events, anchorNumber) => {
        return (
            <div id={'resultContainer'} style={{backgroundColor: mode.settings.backgroundColor}}>
                <Container className={'container'} id={sliceMax == 2?'anchor'+anchorNumber:''}>
                    {renderTitle('Evènements',  <img style={{ height : '25px', width : '40px' }}
                                                     src={`/assets/icon/event-white.png`}
                                                     alt={'Résultats de catégorie Evènements'}
                    />, 7)}
                    <div>
                        {events.slice(0,sliceMax).map((event,index) => (
                            <div key={index} id={sliceMax > 2?'anchor'+index:''}>
                                <EventDetailCardRender theEvent={event}/>
                            </div>
                        ))}
                    </div>
                    <br/>
                    {
                        sliceMax == 2 ?
                            <div style={{textAlign:"center", marginTop:-18}}>
                                <Button startIcon={<RemoveRedEyeIcon role={'img'} aria-label="Voir tous les résultats évenements"/>}
                                        className='buttonOhs'
                                        onClick={() => {
                                            changeTab(7)
                                        }}
                                >
                                    <Typography variant={'subtitle3'}>Voir toutes les évenements</Typography>
                                </Button><br/>
                            </div>
                            :''
                    }
                    <br/>
                </Container>
            </div>
        )
    }

    const renderTitle = (title, icon, number) => {
        return (
            <div id={"titleContainer"}>
                <div className="startBorderShadow"></div>
                <Button className='searchTitle' startIcon={icon}
                    onClick={() => {
                        changeTab(number)
                    }}
                >
                    <Typography variant={'subtitle14'}>
                        {title}
                    </Typography>
                </Button>
                <div className="endBorderShadow"></div>
                <br/>
            </div>
        )
    }

    const renderCommunity = (community, anchorNumber) => {

        const settingsCommunity = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: community.length < 3 ? community.length : 3,
            centerPadding: '-15px',
            centerMode: true,
            responsive: [
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 1,
                        variableWidth : false,
                        arrows : false,
                        centerPadding: '0px',
                    },
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        variableWidth : false,
                        centerPadding: '0px',
                    },
                }
            ],
            variableWidth : false
        };
        return (
            <div id={'resultContainer'} style={{backgroundColor: mode.settings.backgroundColor}}>
                <Container className={'container'} id={'anchor'+anchorNumber}>
                    {renderTitle('Communautés', <img style={{ height : '25px', width : '30px' }}
                                                     src={`/assets/icon/communauté-white.png`}
                                                     alt={'Résultat de catégorie communautés'}
                    />, 4)}
                    <div style={{marginTop:-9}}>
                        {
                            community.length > 2 ?
                                <Slider {...settingsCommunity}>
                                    {community.map((community_child,index) => (
                                        <div key={index}>
                                            <CommunityCard
                                                community={community_child}
                                                sx={{
                                                    width: {xs : '360px' , md : '380px', lg : '380px'},
                                                    ml: {xs : 'auto !important' , md : 'auto !important', lg : '0px !important'},
                                                    mr: {xs : 'auto !important' , md : 'auto !important', lg : '0px !important'},
                                                }}
                                                member={true}
                                            />
                                        </div>
                                    ))}
                                </Slider>:
                                <Stack direction={'row'} gap={'34px'}>
                                    {community.map((community, index) => (
                                        <div key={index}>
                                            <CommunityCard community={community}
                                                           sx={{
                                                               width: {xs: '360px', md: '380px', lg: '380px'},
                                                               ml: {
                                                                   xs: 'auto !important',
                                                                   md: 'auto !important',
                                                                   lg: '0px !important'
                                                               },
                                                               mr: {
                                                                   xs: 'auto !important',
                                                                   md: 'auto !important',
                                                                   lg: '0px !important'
                                                               },
                                                           }}
                                                           member={true}
                                            />
                                        </div>
                                    ))}
                                </Stack>
                        }
                    </div>
                    {
                        sliceMax == 2 ?
                            <div style={{textAlign:"center", marginTop:8}}>
                                <Button startIcon={<RemoveRedEyeIcon role={'img'} aria-label="Voir toutes les communautés"/>}
                                        className='buttonOhs'
                                        onClick={() => {
                                            changeTab(4)
                                        }}
                                >
                                    <Typography variant={'subtitle3'}>Voir toutes les communautés</Typography>
                                </Button><br/>
                            </div>
                            :''
                    }
                    <br/>
                </Container>
            </div>
        )
    }

    const renderInstitution = (institution, anchorNumber) => {
        console.log(institution.length, institution)
        const settingsInstitution = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: institution.length < 3 ? institution.length : 3,
            centerPadding: '-15px',
            centerMode: true,
            responsive: [
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 1,
                        variableWidth : false,
                        arrows : false
                    },
                },
                {
                    breakpoint: 1300,
                    settings: {
                        slidesToShow: 2,
                        variableWidth : false,
                        centerPadding: '0px',
                    },
                }
            ],
            variableWidth : false
        };
        return (
            <div id={'resultContainer'} style={{backgroundColor: mode.settings.backgroundColor}}>
                <Container id={'anchor'+anchorNumber} className={'container'}>
                    {renderTitle('Etablissements', <ApartmentIcon role="img"
                                                                  aria-label="Résultats de la catégorie établissement"></ApartmentIcon>, 5)}
                    <Slider {...settingsInstitution}>
                        {institution.map((institution_child,index) => (
                            <Box key={index}
                                 sx={{
                                     width: '330px',
                                     ml: {xs : 'auto !important' , md : 'auto !important', lg : institution.length > 3 ? '34px !important' : '0px !important'},
                                     mr: {xs : 'auto !important' , md : 'auto !important', lg : '0px !important'},
                                 }}
                            >
                                <InstitutionCard institution={institution_child} />
                            </Box>
                        ))}
                    </Slider>

                    {
                        sliceMax == 2 ?
                            <div style={{textAlign:"center", marginTop:13}}>
                                <Button startIcon={<RemoveRedEyeIcon role={'img'} aria-label="Voir tous les établissements"/>}
                                        className='buttonOhs'
                                        onClick={() => {
                                            changeTab(5)
                                        }}
                                >
                                    <Typography variant={'subtitle3'}>Voir tous les établissements</Typography>
                                </Button><br/>
                            </div>
                            :''
                    }
                    <br/>
                </Container>
            </div>
        )
    }

    const move = (direction, headerHeight) => {
        const tempPosition = anchor + direction;
        const tempAnchor = 'anchor'+tempPosition;
        const anchorEl = document.getElementById(tempAnchor);
        if (anchorEl) {
            window.scrollTo({
                top: anchorEl.offsetTop - headerHeight,
                behavior: "smooth",
            });
            setAnchor(anchor + direction);
        }
        const nextPosition = tempPosition + direction;
        if (document.getElementById('anchor'+nextPosition) == null && (direction < 0)) {
            setShowMoveDownButton(true);
            setShowMoveUpButton(false);
        } else if (document.getElementById('anchor'+nextPosition) == null) {
            setShowMoveDownButton(false);
            setShowMoveUpButton(true);
        } else {
            setShowMoveUpButton(true);
            setShowMoveDownButton(true);
        }
    };

    return (
        <div>
            {
                showMoveUpButton ?
                    <Box sx={{position: 'fixed', right: 0, top: '25%'}}>
                        <IconButton
                            className={'btn-gradient'}
                            sx={{
                                color: '#FFFFFF',
                                borderRadius: 0,
                                borderTopLeftRadius: '10%',
                                borderBottomLeftRadius: '10%'
                            }}
                            onClick={() => move(-1,process.env.REACT_APP_HEADER_HEIGHT)}
                        >
                            <ArrowUpwardIcon aria-label="Remonter au bloc précédent" role="img"/>
                        </IconButton>
                    </Box> : <div></div>
            }
            {
                showMoveDownButton ?
                    <Box sx={{position: 'fixed', right: 0, top: '32%'}}>
                        <IconButton
                            className={'btn-gradient'}
                            sx={{
                                color: '#FFFFFF',
                                borderRadius: 0,
                                borderTopLeftRadius: '10%',
                                borderBottomLeftRadius: '10%'
                            }}
                            onClick={() => move(1,process.env.REACT_APP_HEADER_HEIGHT)}
                        >
                            <ArrowDownwardIcon aria-label="Descendre au bloc suivant" role="img"/>
                        </IconButton>
                    </Box>: <div></div>
            }
            <div>{renderResult(searchResponse)}</div>
            <br/>
        </div>
    )
}

export default Result;
